import { getCurrentInstance } from 'vue'

export function useAppContext () {
  const { proxy } = getCurrentInstance()

  return {
    trans: proxy.$t,
    router: proxy.$router,
    route: proxy.$route,
    vuetify: proxy.$vuetify
  }
}
